import { useMemo } from 'react';
import { useRouteResources } from '@lp/features/RoutePlanner/hooks/useRouteResources';
import {
  CaseClinicalSpecialistResource,
  CaseOCSConsoleResource,
  CaseResource,
  CaseResourceType,
  CaseRetrievalSurgeonResource,
} from '@/api/apis/case';

type CSResourceListType = {
  type: CaseResourceType.ClinicalSpecialist;
  item?: CaseResource<CaseClinicalSpecialistResource>;
};

type DeviceResourceListType = {
  type: CaseResourceType.OCSConsole;
  item?: CaseResource<CaseOCSConsoleResource>;
};

type RSResourceListType = {
  type: CaseResourceType.Surgeon;
  item?: CaseResource<CaseRetrievalSurgeonResource>;
};

export type ResourceListType = CSResourceListType | DeviceResourceListType | RSResourceListType;

export const useResourcesList = () => {
  const { ClinicalSpecialist: specialists, OCSConsole: devices, Surgeon: surgeons } = useRouteResources();

  return useMemo(() => {
    const mappedSpecialists: CSResourceListType[] = specialists.length
      ? specialists.map((item) => ({
          type: CaseResourceType.ClinicalSpecialist,
          item,
        }))
      : [{ type: CaseResourceType.ClinicalSpecialist }];

    const mappedDevices: DeviceResourceListType[] = devices.length
      ? devices.map((item) => ({
          type: CaseResourceType.OCSConsole,
          item,
        }))
      : [{ type: CaseResourceType.OCSConsole }];

    const mappedSurgeons: RSResourceListType[] = surgeons.length
      ? surgeons.map((item) => ({
          type: CaseResourceType.Surgeon,
          item,
        }))
      : [{ type: CaseResourceType.Surgeon }];

    return [...mappedSpecialists, ...mappedDevices, ...mappedSurgeons];
  }, [specialists, devices, surgeons]);
};
